function References() {
  return (
    <div className="p-8   bg-gray-50 shadow-sm rounded-lg">
      <h1 className="text-xl font-bold uppercase mb-4 text-blue-700 border-b border-gray-300 pb-2">References</h1>
      <div className="p-2 hover:bg-blue-50 rounded-md transition-colors">
        <h3 className="font-bold text-blue-600">Mr. Assaduzzaman</h3>
        <p className="text-gray-700">Daffodil International University</p>
        <p className="text-gray-700">Ashulia, Savar, Dhaka</p>
        <p className="text-gray-700">+8801824089009</p>
      </div>
    </div>
  );
}

export default References;